import { setACL } from '@acl/acl.store';
import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { of, zip } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';

import { User, setUser } from '../store';
import { WatermarkService } from './../../layout/watermark/watermark.service';
import { EnterpriseService } from './enterprise.service';
import { UserService } from './user.service';
import { I18nMessageService } from './i18nMessage.service';
import { MenuService } from './menu.service';
import { TranslateService } from './translate.service';

/**
 * Used for application startup
 * Generally used to get the basic data of the application, like: Menu Data, User Data, etc.
 */
@Injectable()
export class StartupService {
  constructor(private readonly store: Store, private readonly injector: Injector) {}

  private viaHttp(resolve: any, reject: any) {
    const userSrv = this.injector.get(UserService);
    return userSrv
      .ping()
      .pipe(
        catchError(userData => {
          resolve(null);
          return userData;
        }),
        filter((userData: any) => userData && userData.userLogin),
        mergeMap((userData: User) => {
          this.store.dispatch(setUser(userData));
          this.store.dispatch(setACL({ acl: userData.permissions ?? [] }));
          const enterpriseSrv = this.injector.get(EnterpriseService);
          const messageServ = this.injector.get(I18nMessageService);
          const watermarkServ = this.injector.get(WatermarkService);
          const menuServ = this.injector.get(MenuService);
          const translateServ = this.injector.get(TranslateService);

          return userData.userStatus === 1
            ? zip(
                enterpriseSrv.enterprise(),
                userSrv.roleAndPermission(),
                userSrv.getAccountSafeInit(),
                userSrv.getCustomerSafeInit(),
                messageServ.getI18nJson(),
                userSrv.getSystemConfig(),
                userSrv.getUserCommonConf(),
                watermarkServ.getWaterMark(),
                menuServ.getMenu(),
                translateServ.getI18nJson()
              )
            : of(null);
        })
      )
      .subscribe(
        (data: any) => {},
        () => {},
        () => {
          resolve(null);
        }
      );
  }

  load(): Promise<any> {
    // only works with promises
    // https://github.com/angular/angular/issues/15088
    return new Promise((resolve, reject) => {
      // http
      this.viaHttp(resolve, reject);
      // mock：请勿在生产环境中这么使用，viaMock 单纯只是为了模拟一些数据使脚手架一开始能正常运行
      // this.viaMock(resolve, reject);
    });
  }
}
